
import $ from 'jquery';

$.fn.smoothScrollTo = function() {
    const offset = this.offset() || {};
    $('html, body').animate({scrollTop: offset.top - 100}, 'slow');
};



// WEBPACK FOOTER //
// ./scripts/scroll-to-hash.js